export const Mode = {
  DEFAULT: 'default',
  AMBIENT: 'ambient',
  WHITE: 'white',
} as const;

export type Mode = Union<typeof Mode>;
